import RetryScreen from './RetryScreen.component';

export default RetryScreen;
